import { useQueryClient } from '@zg-rentals/react-query5';
import {
  useCappsLandlordPropertyDetailsWebApiHandler_details,
  useCappsLandlordPropertyDetailsWebApiHandler_updateApplicationsAccepted,
} from '@zg-rentals/ts-capps-client-react-query';

export function useUpdateApplicationsAccepted(listingAlias: string) {
  const queryClient = useQueryClient();
  const {
    mutateAsync,
    mutate: _,
    variables: __,
    ...rest
  } = useCappsLandlordPropertyDetailsWebApiHandler_updateApplicationsAccepted({
    onSuccess: (_data, { postData: { applicationsAccepted } }) => {
      queryClient.setQueryData(
        useCappsLandlordPropertyDetailsWebApiHandler_details.getKey({ listingAlias }),
        (oldData) => (oldData ? { ...oldData, applicationsAccepted } : oldData),
      );
    },
  });

  return {
    ...rest,
    mutateAsync: (applicationsAccepted: boolean) => mutateAsync({ postData: { listingAlias, applicationsAccepted } }),
  };
}
